import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
// todo: add color in muitheme
import { green } from '@mui/material/colors';

const useIntegrationStyles = makeStyles((theme: Theme) => {
  return {
    analyticsContent: {
      // position: 'relative',
      height: `calc(100% - 68px - 24px - 24px - 24px - 24px)`,
      overflowY: "auto",
      padding: '24px 0px'
    },
    integration: {
      flex: 1,
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      paddingTop: theme.spacing(3),
      paddingLeft: theme.spacing(3),
      gap: theme.spacing(2),
      textAlign: "left",
      height: "100%",
      marginLeft: 18,
      width: "100%",
    },
    gCalendarParent: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: "30px",
    },
    integrationIcon: {
      position: "relative",
      height: "48px",
      objectFit: "cover",
    },
    calendarStatus: {
      textTransform: 'none',
      borderRadius: "4px",
      border: "1px solid rgba(229, 229, 229, 1)",
      padding: '2px 4px', 
      minHeight: '24px', 
      display: 'flex',
      alignItems: 'center',
    },
    settingsCalendarStatus: {
      textTransform: 'none',
      borderRadius: "4px",
      border: "1px solid rgba(207, 198, 198, 1)",
      padding: '4px 6px', 
      minHeight: '24px', 
      display: 'flex',
      alignItems: 'center',
      backgroundColor: theme.palette.background.paper,
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },
    connected: {
      color: green[500]
    },
    connect: {
      color: theme.palette.success.light
    },
    disconnect: {
      color: theme.palette.grey[600]
    },
    calendarDelete: {
      textTransform: 'none',
      borderRadius: theme.shape.borderRadius,
      border: `1px solid ${theme.palette.error.light}`,
      padding: "4px 8px",
      fontWeight: 600
    },
    delete: {
      color: theme.palette.error.light
    },
    sync: {
      color: "#6036D6",
      width: "16px",
      height: "16px",
    },
    settingsSync: {
      color: "#6036D6",
      width: "18px",
      height: "18px",
    },
    calendarWrapper: {
      flex: "1",
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      justifyContent: "space-between",
      color: "#000",
      gap: theme.spacing(16),
    },
    calendar: {
      lineHeight: "24px",
      fontWeight: 500,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      display: "flex",
      gap: theme.spacing(2),
      alignItems: 'center'
    },
    frameParent: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: theme.spacing(2),
      marginTop: theme.spacing(1),
    },
    notes: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
      fontSize: "12px",
      color: "#071f41",
    },
    remindersWrapper: {
      alignSelf: 'stretch',
      position: "relative",
    },
    topSection: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: theme.spacing(2),
    },
    bottomSection: {
      display: "flex",
      flexDirection: "row",
      marginTop: 50,
      gap: theme.spacing(25),
    },
    calendarInfo: {
      display: "flex",
      flexDirection: "column",
    },
    infoIcon: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    syncText: {
      color: '#6036D6',
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: '16px',
    },
    settingsSyncText: {
      color: '#6036D6',
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '16px',
    },
  }
})

export default useIntegrationStyles






